module.exports = __webpack_public_path__ + "img/black-x.fa6548a0.svg";